import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=faaa6802&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"
import style0 from "./experience.vue?vue&type=style&index=0&id=faaa6802&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaa6802",
  null
  
)

export default component.exports